<template>
  <div class="eco-resp-page">
    <div class="eco-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">领导干部经济责任审计智能评价系统</span>
      </nav>
    </div>

    <!-- 英雄区 -->
    <section class="eco-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>领导干部经济责任审计智能评价系统<br><span style="color: var(--eco-accent-blue);">自动评分 · 智能算法 · 干部监督</span></h1>
        <p class="subhead">构建"标准化指标 + 负面清单 + 自动评分"的智能经责审计评价体系，助力央企国企实现干部监督数字化、评价科学化。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">经济责任审计</h2>
        <h2 class="keyword-tag">领导干部审计</h2>
        <h2 class="keyword-tag">经责审计系统</h2>
        <h2 class="keyword-tag">智能审计</h2>
        <h2 class="keyword-tag">干部评价系统</h2>
        <h2 class="keyword-tag">自动评分</h2>
        <h2 class="keyword-tag">负面清单管理</h2>
        <h2 class="keyword-tag">审计智能化</h2>
        <h2 class="keyword-tag">审计监督体系</h2>
        <h2 class="keyword-tag">数字化审计</h2>
      </div>
    </section>

    <!-- 背景与挑战 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 传统经责审计的挑战</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-scale-balanced"></i></div>
          <h3>评价标准不统一</h3>
          <p>不同审计人员评分尺度不一，评价维度分散，难以形成可比性数据。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-clipboard"></i></div>
          <h3>底稿与评价割裂</h3>
          <p>审计发现问题无法自动映射评价维度，评分过程主观性强。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-line"></i></div>
          <h3>数据难以沉淀</h3>
          <p>审计数据分散，指标口径不统一，历史数据无法有效利用。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">随着《审计法》及《党政主要领导干部经济责任审计规定》的深入实施，构建智能化、标准化的经责审计评价平台成为刚需。</p>
    </section>

    <!-- 解决方案核心功能 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-cubes"></i> 五大核心能力</h2>
      <div class="card-grid-4">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-file-lines"></i></div>
          <h3>经责审计标准作业卡</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 不同类型项目配置目标</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 个性化检查点预置</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 统一指标体系</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-list-check"></i></div>
          <h3>审计问题线上化</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 结构化管理审计问题</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支持结构化与非结构化数据</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 审前问题前置</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-database"></i></div>
          <h3>审计数据资产池</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 结构化指标库</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 历史评价数据沉淀</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑持续监督</li>
          </ul>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-brain"></i></div>
          <h3>智能算法评价模型</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 多维度评价模型</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 负面清单指标映射</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 减少人为偏见与噪声</li>
          </ul>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <p><strong>+ 自动评分一体化：</strong> 审计底稿与评价维度自动关联，边审计边评分，实时生成量化结果。</p>
      </div>
    </section>

    <!-- 智能算法特色 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-microchip"></i> AI智能评分机制</h2>
      <div class="arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="compliance-badge">负面清单驱动</span>
          <span class="compliance-badge">多维度权重</span>
          <span class="compliance-badge">机器学习辅助</span>
          <span class="compliance-badge">偏差控制</span>
        </div>
        <div class="arch-grid">
          <div class="arch-item">
            <i class="fa-regular fa-list" style="font-size: 2rem; color: var(--eco-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>指标映射引擎</h4>
            <p>将审计问题自动关联至经济责任、财务责任、风险管理等维度，形成统一评分基础。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-weight-scale" style="font-size: 2rem; color: var(--eco-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>动态权重配置</h4>
            <p>根据行业、岗位、任期等因素自定义评价权重，支持组织差异化需求。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-robot" style="font-size: 2rem; color: var(--eco-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>智能校准</h4>
            <p>利用历史审计数据训练模型，持续优化评分算法，降低主观噪声。</p>
          </div>
        </div>
        <p style="margin-top: 30px; text-align: center;">最终实现 <strong>"审计底稿→问题→评分→报告"</strong> 全流程自动化，评价结果可追溯、可解释。</p>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-building"></i> 典型应用场景</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <h3>领导干部任期经责审计</h3>
          <p>任期内履职情况评价、财务责任履行、风险管理能力分析，自动生成任期评分报告。</p>
        </div>
        <div class="feature-card">
          <h3>国企领导人员经责审计</h3>
          <p>重大决策合规性、投资风险责任、经营绩效评价，辅助组织人事决策。</p>
        </div>
        <div class="feature-card">
          <h3>干部监督管理</h3>
          <p>干部履职能力分析、负面清单管理、审计结果辅助干部选拔任用。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 项目成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">30%-50%</div>
          <p>审计效率提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">100%</div>
          <p>评分自动化覆盖</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">60%</div>
          <p>主观偏差降低</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">5年+</div>
          <p>历史数据沉淀</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 实现经责审计评分自动化，降低人工评分主观性，提升公平性与科学性。</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑央企国企干部监督体系建设，审计结果辅助组织决策。</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 构建持续监督审计机制，多期数据对比分析，助力审计数字化转型。</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户类型 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-users"></i> 适用客户群体</h2>
      <div class="client-tags">
        <span class="client-tag">中央企业集团</span>
        <span class="client-tag">地方国资委</span>
        <span class="client-tag">大型国有企业</span>
        <span class="client-tag">金融控股集团</span>
        <span class="client-tag">能源/电力/通信企业</span>
        <span class="client-tag">政府审计部门</span>
      </div>
    </section>

    <!-- 客户成功案例 -->
    <section class="eco-container">
      <h2><i class="fa-regular fa-briefcase"></i> 客户成功案例</h2>
      <div class="card-grid-3">
        <div class="case-card">
          <i class="fa-solid fa-building-columns" style="font-size: 2rem; color: var(--eco-primary-dark);"></i>
          <div class="case-stats">-40%</div>
          <p><strong>某能源央企</strong> — 上线智能评价系统后，经责审计项目周期缩短40%，干部评价数据实现年度对比分析。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-phone" style="font-size: 2rem; color: var(--eco-primary-dark);"></i>
          <div class="case-stats">+50%</div>
          <p><strong>省级通信集团</strong> — 通过负面清单自动映射，评价指标覆盖率提升50%，评分一致性显著提高。</p>
        </div>
        <div class="case-card">
          <i class="fa-solid fa-truck" style="font-size: 2rem; color: var(--eco-primary-dark);"></i>
          <div class="case-stats">100%</div>
          <p><strong>地方国资平台</strong> — 实现所监管企业领导干部任期审计全量化评分，评价结果直接应用于干部考核。</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="eco-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 系统如何保证评价的公平性？</div>
          <div class="faq-answer">系统内置算法模型，将审计问题自动映射至统一指标库，减少人工干预；同时通过权重配置和机器学习校准，降低主观偏差。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 能否适配不同行业、不同类型的领导干部？</div>
          <div class="faq-answer">可以。系统支持自定义指标模板，可针对企业领导、事业单位负责人、政府部门干部等设置差异化评价维度和权重。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持与现有的审计作业系统对接？</div>
          <div class="faq-answer">支持标准API接口，可对接用友、金蝶、SAP等财务系统，以及古杉非现场审计平台，实现数据自动同步。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何利用历史数据进行对比分析？</div>
          <div class="faq-answer">系统建立审计数据资产池，可存储多年评价结果，支持任期前后对比、同类型干部横向对比，为组织决策提供数据支撑。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 实施需要多长时间？</div>
          <div class="faq-answer">一般2-3个月完成试点上线，包括指标体系梳理、系统配置、历史数据迁移和人员培训。我们提供敏捷交付模式。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="eco-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">构建智能经责审计评价体系</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何实现干部审计自动评分与监督数字化。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--eco-primary-dark);">预约免费演示</a>
          <a href="tel:4008881234" class="btn btn-outline" style="border-color: white; color: white;">致电 400-888-1234</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 leaderaudit@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--eco-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="eco-container">
      <p>© 2026 古杉数据 · 领导干部经济责任审计智能评价系统 | 自动评分 · 智能监督</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'EconomicResponsibilityAuditDetail',
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.eco-resp-page {
  --eco-primary-dark: #1D4E4E;
  --eco-primary-soft: #e9f3f2;
  --eco-accent-gold: #D4AF37;
  --eco-accent-blue: #2A7DE1;
  --eco-gray-light: #f8fafc;
  --eco-gray-border: #e2e8f0;
  --eco-text-dark: #0f2a2a;
  --eco-text-regular: #2d3f4b;
  --eco-white: #ffffff;
  --eco-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--eco-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  padding: 20px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--eco-gray-border);
  margin-bottom: 20px;
}

.breadcrumb-nav a {
  color: var(--eco-primary-dark);
  text-decoration: none;
  font-weight: 500;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--eco-accent-blue);
  font-weight: 600;
}

.eco-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.eco-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--eco-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--eco-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--eco-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--eco-primary-dark);
  color: var(--eco-primary-dark);
}

.btn-outline:hover {
  background-color: var(--eco-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--eco-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--eco-primary-soft);
  color: var(--eco-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--eco-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--eco-shadow);
  border: 1px solid var(--eco-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--eco-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--eco-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--eco-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--eco-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--eco-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--eco-text-dark);
}

.case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--eco-shadow);
}

.case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--eco-primary-dark);
  margin: 16px 0 8px;
}

/* 技术架构卡片 */
.arch-card {
  background: var(--eco-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.compliance-badge {
  display: inline-block;
  background: var(--eco-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--eco-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--eco-text-dark);
}

.faq-question i {
  color: var(--eco-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.cta-block {
  background: var(--eco-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.cta-block h2 {
  color: white;
}

.cta-block .btn-primary {
  background-color: white;
  color: var(--eco-primary-dark);
  margin: 0 8px;
}

.cta-block .btn-outline {
  border-color: white;
  color: white;
}

.cta-block .btn-outline:hover {
  background-color: white;
  color: var(--eco-primary-dark);
}

/* 模态框 */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal h3 {
  margin-bottom: 24px;
}

.modal .form-group {
  margin-bottom: 20px;
}

.modal input, .modal textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--eco-gray-border);
  border-radius: 30px;
  font-size: 1rem;
  outline: none;
}

.modal textarea {
  border-radius: 20px;
}

.modal .btn {
  width: 100%;
  margin-top: 10px;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--eco-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: 1fr;
  }
  .eco-resp-page h1 { font-size: 2.5rem; }
}
</style>
